import { useQuery } from 'react-query'
import dataAPI from '../../services/dataAPI'

export default function useNbCuts(deviceId?: string) {
  const nbCutsQuery = useQuery({
    queryKey: ['nb-cuts', deviceId],
    queryFn: () => dataAPI.getNBCuts(deviceId || ''),
    enabled: !!deviceId, // Only run query if deviceId is provided
  })

  return {
    nbCutsQuery: {
      data: nbCutsQuery.data,
      isLoading: nbCutsQuery.isLoading,
      isSuccess: nbCutsQuery.isSuccess,
      isError: nbCutsQuery.isError,
      error: nbCutsQuery.error,
      refetch: nbCutsQuery.refetch,
      isRefetching: nbCutsQuery.isRefetching
    }
  }
}

